import './styles/article.scss';

import { useLocale } from 'next-intl';

import ArticleContent from './ArticleElements/ArticleContent';
import ArticleFooter from './ArticleElements/ArticleFooter';
import { HeaderComponent } from './ArticleElements/ArticleHeader';
import { ArticlePremiumContentPercentageLabels } from './atoms/ArticlePremiumContentPercentage';

import { AnalyticsParams } from '@components/Analytics/Google/GAScript';
import { ArticleI, ArticleViewType, ProcessedArticleI } from 'types/article';

export interface ArticleLabels {
  textPodcast: string;
  premiumContentPercentage: ArticlePremiumContentPercentageLabels;
  shareBarTitle: string;
  videoPremiumOnly: string;
  tags: string;
}

interface ArticleProps {
  article: ProcessedArticleI;
  promotedArticles?: ArticleI[];
  viewType: ArticleViewType;
  mainArticle: boolean;
  labels: ArticleLabels;
  analyticsData: AnalyticsParams;
}

export default function Article({ article, viewType, mainArticle, analyticsData }: ArticleProps) {
  const lang = useLocale();

  return (
    <div className="block px-3 py-4 lg:px-4 lg:py-8 lg:pb-16">
      <HeaderComponent
        article={article}
        showGraphic={viewType !== 'video'}
        viewReadingTime={viewType === 'article'}
        viewArticleInfoBar={true}
        viewSpeechSynthesis={lang === 'pl' && viewType === 'article'}
      />

      <ArticleContent viewType={viewType} article={article} analyticsData={analyticsData} />
      <ArticleFooter
        article={article}
        mainArticle={mainArticle}
        showComments={lang === 'pl'}
        showTags={true}
        viewType={viewType}
        analyticsData={analyticsData}
      />
    </div>
  );
}
